export class ProblemList {
    totalItem?: number;
    problemListId: number;
    name: string;
    description?: string;
    createdBy: number;
    createdDate: Date;
    modifiedBy?: number;
    modifiedDate: Date;
}